import { GetterTree, Store } from "vuex";
import { IRootState } from "../types";
import { buildGetter } from "@dcc/store/utils";
import { ActivityState } from "./types";
import { ActivityCategory } from "@dcc/types/activityCategory";
import { Activity } from "@dcc/types/activity";

const getterNames = {
  ...ActivityCategory,
  GETSELECTEDIDS: "GetSelectedIds",
  GETSELECTEDACTIVITIES: "GetSelectedActivities",
  GETALLACTIVITIES: "GetAllActivities",
  GETSELECTEDCOUNT: "GetSelectedCount"
};

export interface ActivityGetters {
  GetSelectedIds: string[];
  GetAllActivities: Activity[];
}

export const getters: GetterTree<ActivityState, IRootState> = {
  [getterNames.ActiveDays](state: ActivityState): Activity[] {
    return state["Active Days"];
  },
  [getterNames.EasyTips](state: ActivityState): Activity[] {
    return state["Easy Tips"];
  },
  [getterNames.Health](state: ActivityState): Activity[] {
    return state["Health"];
  },
  [getterNames.GETSELECTEDIDS](state: ActivityState): string[] {
    return state.selected;
  },
  [getterNames.GETALLACTIVITIES](
    state: ActivityState,
    getters: ActivityGetters
  ): Activity[] {
    return [...state["Active Days"], ...state["Health"], ...state["Easy Tips"]];
  },
  [getterNames.GETSELECTEDACTIVITIES](
    state: ActivityState,
    getters: ActivityGetters
  ): Activity[] {
    const selectedIds = getters["GetSelectedIds"];
    const allActivities = getters["GetAllActivities"];
    return allActivities.filter((a) => selectedIds.includes(a.id));
  },
  [getterNames.GETSELECTEDCOUNT](
    state: ActivityState,
    getters: ActivityGetters
  ): number {
    const activities = getters["GetSelectedIds"];
    return activities.length;
  }
};

export const findGetters = (store: Store<IRootState>) => {
  return {
    getByCategory: (category: ActivityCategory) =>
      buildGetter<Activity[]>(store, "activity", category),
    getSelectedIds: () =>
      buildGetter<number[]>(store, "activity", getterNames.GETSELECTEDIDS),
    getSelectedActivities: () =>
      buildGetter<Activity[]>(
        store,
        "activity",
        getterNames.GETSELECTEDACTIVITIES
      ),
    getSelectedCount: () =>
      buildGetter<number>(store, "activity", getterNames.GETSELECTEDCOUNT),
    getAllActivities: () =>
      buildGetter<Activity[]>(store, "activity", getterNames.GETALLACTIVITIES)
  };
};
